module.exports = __webpack_public_path__ + "static/media/OurStory-TealBlockVertical.ffca1fd2.svg";